query pastaSelect {
    data: pastas(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}